import './MessageChatRow.scss';

import { Typography } from 'antd';
import dayjs from 'dayjs';
import { useMemo } from 'react';

import { useUserContext } from '@/contexts/UserContext';
import { MessageChat } from '@/model/General/MessageChat';

interface MessageChatRowProps {
  message: MessageChat;
}

const MessageChatRow = (props: MessageChatRowProps) => {
  const { message } = props;
  const { userLogged } = useUserContext();
  const displayName = useMemo(() => {
    const firstName = message.origin_user_data?.firstName ?? '';
    const lastName = message.origin_user_data?.lastName ?? '';
    const fullName = `${firstName} ${lastName}`.trim();

    return fullName || message.origin_user_data?.username || 'Usuario';
  }, [message.origin_user_data]);
  const userColor = useMemo(() => {
    const seed = displayName || '';
    let hash = 0;

    for (let i = 0; i < seed.length; i += 1) {
      hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;

    return `hsl(${hue}, 60%, 45%)`;
  }, [displayName]);
  const selfMessage = useMemo(
    () =>
      message.origin_user_data == undefined
        ? true
        : userLogged?.username == message.origin_user_data?.username,
    [message.origin_user_data, userLogged?.username],
  );

  return (
    <div className={`MessageChatRow ${selfMessage ? 'SelfMessage' : ''}`}>
      <div className="MessageChatRowContent">
        <div className={'MessageChatRowHeader'}>
          <span className={'MessageChatRowUser'} style={{ color: userColor }}>
            {displayName}
          </span>
        </div>
        <div className={'MessageChatRowText'}>{message.text}</div>
      </div>

      <span className={'MessageChatRowDate'}>
        <Typography.Text type="secondary">{dayjs(message.date).format('L HH:mm')}</Typography.Text>
      </span>
    </div>
  );
};

export default MessageChatRow;
